export const BOOKING_TICKET_POLL_DELAYS_MS = [5_000, 10_000, 20_000, 30_000, 60_000, 60_000, 60_000, 60_000] as const;

/**
 * Próximo intervalo del sondeo iniciado por el asesor. El endpoint puede
 * responder `ready: false` mientras el proveedor prepara el documento; el
 * cliente reintenta durante unos cinco minutos y después vuelve a dejar la
 * decisión en manos del asesor.
 */
export function bookingTicketPollDelay(pendingResponses: number): number | false {
  const index = Math.max(0, pendingResponses - 1);
  return BOOKING_TICKET_POLL_DELAYS_MS[index] ?? false;
}

/**
 * Los tickets pertenecen a UNA reserva. La identidad pedida se conserva por
 * separado para que cambiar de modal invalide inmediatamente la respuesta
 * visible, aunque la consulta anterior termine más tarde.
 */
export function bookingTicketRequestIsActive(
  requestedBookingId: string | null,
  currentBookingId: string | undefined,
): boolean {
  return Boolean(currentBookingId && requestedBookingId === currentBookingId);
}

export function bookingTicketScopeIsActive(
  requestedScopeKey: string | null,
  currentScopeKey: string | undefined,
): boolean {
  return requestedScopeKey === currentScopeKey;
}

export const bookingTicketsQueryKey = (bookingId: string | undefined) => ['travelBookingTickets', bookingId] as const;
